import * as THREE from 'three';
import * as marietta from '../..';
import { ItemControllerBasePointInput } from '.';
import { SVGSprite } from '../flash/display';
import * as graphicLibs from '../../graphicLibs/index';
import { PointCollection } from '../collection';
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE, ITEM_MODE_NO } from '../Constants';
import { CalculationUtil } from '../util';

/**
 * 部屋ポイント入力を作成するためのクラス
 */
class ItemControllerRoomPointInput extends ItemControllerBasePointInput {
  roomPointList: marietta.core.Point[][] = [];

  /**
   * コンストラクタ
   */
  constructor() {
    super();
    this.type = (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_WALL) ? 'wall' : 'room';

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      this.isRoomWallSnap = false;
      const selectedItem = this.type === 'wall' ? '' : String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
      const devide: boolean = (selectedItem === 'col01_01' || selectedItem === 'bem01_01');
      if (this.type === 'room' && devide) this.hasRoomWallSnap = false;
      this.createRoomVectorList();
      this.spt.element.remove();
      const viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      const tar: SVGRectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      viewObj.appendChild(tar);
      tar.setAttribute('width', '50px');
      tar.setAttribute('height', '50px');
      tar.setAttribute('x', '-25');
      tar.setAttribute('y', '-25');
      tar.setAttribute('opacity', '0');
      viewObj.setAttribute('id', 'controller_pen');
      this.tarLayer.viewObj.appendChild(viewObj);
      this.spt = new SVGSprite(viewObj);
    }
  }

  /**
   * ドットの作成
   * @param MouseEvent
   */
  makeDotAt(newPoint: marietta.core.Point) {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE) {
      super.makeDotAt(newPoint);
    } else {
      // 前のライン類の終点指定
      if (this.currentLine !== undefined) {
        this.currentLine.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
        this.currentText.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
      }

      this.createDotImage(newPoint);

      // ラインの作成
      this.currentLine = new marietta.webcad.control.parts.StretchLineWall(this.dotImage, this.dotList.length);
      this.currentLine.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
      this.currentLine.secondDot = marietta.webcad.WebCADGlobal.userAgentManager.isPC ? new marietta.core.Point(this.mousePlace.x, this.mousePlace.y) : new marietta.core.Point(newPoint.x, newPoint.y);

      // テキスト
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
        this.currentText.firstDot = newPoint;
        this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      } else {
        if (this.currentText) (this.currentText as marietta.webcad.control.parts.StretchLineWallText).switchToTextView();
        this.currentText = new marietta.webcad.control.parts.StretchLineWallText(this.dotImage, this.dotList.length);
        this.currentText.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
        this.currentText.secondDot = new marietta.core.Point(this.mousePlace.x, this.mousePlace.y);
        (this.currentText as marietta.webcad.control.parts.StretchLineWallText).updateLine = this.updateLineByTextInput;
      }
    }
  }

  /**
   * テキストボックス入力で壁を作成する
   * @param distance
   */
  updateLineByTextInput = (distance: number) => {
    const distInPix = marietta.webcad.util.WebCADUtil.convertMMToPix(distance);
    const newPoint = marietta.webcad.util.WebCADUtil.findPointAlongLine(this.currentText.firstDot, this.currentText.secondDot, distInPix);
    marietta.webcad.WebCADGlobal.snapManager.hideAll();

    this.spt.x = newPoint.x;
    this.spt.y = newPoint.y;
    this.spt.update();

    // 最後のラインの伸び縮
    if (this.currentLine !== undefined) {
      this.currentLine.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
      this.currentText.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
    }

    // マウス場所保持

    this.mousePlace = new marietta.core.Point(newPoint.x, newPoint.y);
    // 寸法入力で確定した点。ダミー要素はこの直後に自分で足すので makeDot では足させない
    this.isMousePlaceSnapped = true;
    const point = new marietta.core.Point(newPoint.x, newPoint.y);

    if (this.dotList.length > 0) {
      // ダミー線分を追加（スナップ用）
      marietta.webcad.WebCADGlobal.snapManager.addLineSegmentSnap(this.snapList, this.dotList[this.dotList.length - 1].x, this.dotList[this.dotList.length - 1].y, newPoint.x, newPoint.y, marietta.webcad.manager.SnapManager.SNAP_RADIUS, 10, null, 'dummy');
    }
    marietta.webcad.WebCADGlobal.snapManager.addPointSnap(this.snapList, newPoint.x, newPoint.y, marietta.webcad.manager.SnapManager.SNAP_RADIUS, 10, null, 'dummy');// ダミーポイントを追加（スナップ用）
    marietta.webcad.WebCADGlobal.snapManager.lowerGuidePriority(this.snapList); // 直近以外のガイドの優先度を下げる

    let a; let b; let
      c;
    ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.horizontalLine(newPoint.y));
    marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY, null, true); // 水平線スナップを追加
    ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.verticalLine(newPoint.x));
    marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY, null, true); // 垂直線スナップを追加

    // 頂点情報の保持
    this.dotList.push(point);

    if (this.dotList.length > 2 && this.isPointOnWall(point) && this.isRoomWallSnap) {
      this.endMakeShape();
    }

    // ラインの作成
    this.currentLine = new marietta.webcad.control.parts.StretchLineWall(this.dotImage, this.dotList.length);
    this.currentLine.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
    this.currentLine.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
    // テキスト
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
      this.currentText.firstDot = newPoint;
      this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
    } else {
      if (this.currentText) (this.currentText as marietta.webcad.control.parts.StretchLineWallText).switchToTextView();
      this.moveMouseEvent = null;
      this.currentText = new marietta.webcad.control.parts.StretchLineWallText(this.dotImage, this.dotList.length);
      this.currentText.firstDot = new marietta.core.Point(newPoint.x, newPoint.y);
      this.currentText.secondDot = new marietta.core.Point(newPoint.x, newPoint.y);
      (this.currentText as marietta.webcad.control.parts.StretchLineWallText).updateLine = this.updateLineByTextInput;
    }
  }

  /**
  * 形状作成の終了
  */
  endMakeShape() {
    if (this.dotList.length > 1) {
      const selectedItem = this.type === 'wall' ? '' : String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
      const devide: boolean = (selectedItem !== 'col01_01' && selectedItem !== 'bem01_01');
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION && devide) {
        // マウスの追従終了
        this.stopFollowMouse();

        marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;

        // 作成用モジュールなど削除する
        this.viewObj.remove();
        this.dotImage.remove();

        // 現在の階の頂点リストを取得する
        const roomList: marietta.webcad.item.Room[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
        const allPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllRoomPointList(roomList);

        marietta.webcad.WebCADGlobal.scene = new graphicLibs.Scene();
        if (allPointList.length > 0) {
          allPointList.forEach((pList: any) => {
            marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.ClosePath(pList));
          });
        }

        // 現在の階の建具の情報を足す
        const wallList: marietta.webcad.item.WallObject[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_WALL_NO)).getAllChildren();
        const wallPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllWallPointList(wallList);
        for (let i: number = 0; i < wallPointList.length; i += 1) {
          marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.Line(new THREE.Vector2(wallPointList[i][0].x, wallPointList[i][0].y), new THREE.Vector2(wallPointList[i][1].x, wallPointList[i][1].y)));
        }

        // just add lines for the lines this controller creates
        for (let i = 1; i < this.dotList.length; i += 1) {
          marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.Line(new THREE.Vector2(this.dotList[i - 1].x, this.dotList[i - 1].y), new THREE.Vector2(this.dotList[i].x, this.dotList[i].y)));
        }
        const polyList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.area();
        const branch = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.branch();
        const outerList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.outer();

        const { points } = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.pointlist;
        const outerPoints = []; // 外側のポイントリスト
        outerList.forEach((outer: number[]) => {
          for (let i = 1; i <= outer.length; i += 1) {
            outerPoints.push({ p1: points[outer[i - 1]], p2: points[outer[i % outer.length]] });
          }
        });

        const targetFloor: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);
        targetFloor.formatLayersNewRoomCreations();
        const areaPoints = [];
        const guidList = [];
        const usedOldRoomIndexes = [];
        // //新しい配列を元に部屋を生成する
        for (let i: number = 0; i < polyList.length; i += 1) {
          if (polyList[i].length >= 3) {
            let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
            const dotList = marietta.webcad.util.WebCADUtil.convertPointListToRoomDotList(polyList[i]);
            // 部屋面積ほぼゼロチェック
            if (marietta.webcad.util.WebCADUtil.isAreaZero(dotList)) continue;
            const existingRoomInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveAreaInfo(roomList, dotList, usedOldRoomIndexes);

            for (let j = 0; j < polyList[i].length - 1; j += 1) {
              areaPoints.push({ p1: polyList[i][j], p2: polyList[i][j + 1] });
            }
            areaPoints.push({ p1: polyList[i][polyList[i].length - 1], p2: polyList[i][0] });

            // 頂点が作成時の頂点と全く同一の場合
            if (marietta.webcad.util.WebCADUtil.checkAllPointsExistInDotList(this.dotList, dotList)) {
              existingRoomInfo.info = null;
            }

            if (existingRoomInfo.info != null) {
              info = existingRoomInfo.info.clone();
              marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveRoomWallInfo(info.globalDotList, dotList);
              info.index = undefined;
              info.x = 0;
              info.y = 0;
              if (guidList.indexOf(info.guid) > -1 || existingRoomInfo.hasShapeChange) {
                info.guid = marietta.webcad.WebCADGlobal.getGuid();
              }
              info.dotList = dotList;
            } else {
              info.x = 0;
              info.y = 0;
              info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
              if (this.type === 'wall') info.id = 'rom10_01';
              info.guid = marietta.webcad.WebCADGlobal.getGuid();
              info.dotList = [];
              let dot: marietta.webcad.collection.PointCollection;
              const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
              for (let k: number = 0; k < dotList.length; k += 1) {
                dot = new marietta.webcad.collection.PointCollection(
                  CalculationUtil.roundValue(dotList[k].x - info.x),
                  CalculationUtil.roundValue(dotList[k].y - info.y),
                  defaultRoomSetting.wallType, dotList[k].guid
                );
                info.dotList.push(dot);
              }

              const textPos = new graphicLibs.utility.labelPosition().labelPosition(polyList[i]);
              info.textPosition = new marietta.core.Point(textPos.x, textPos.y);
            }
            guidList.push(info.guid);
            marietta.webcad.WebCADGlobal.itemManager.createItem(info);
          }
        }
        const wallpoints = [];
        if (branch.length > 0) {
          const nodes = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.adjacencyList;
          nodes.forEach((pointList, index: number) => {
            const pos1: THREE.Vector2 = points[index];

            pointList.forEach((pointIndex: number) => {
              if (branch[index] !== -1) {
                // TODO:壁を書く
                if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, wallpoints) && !marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, areaPoints)) {
                  let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
                  info.x = 0;
                  info.y = 0;
                  info.id = 'wal01_01';
                  info.dotList = [new PointCollection(pos1.x, pos1.y), new PointCollection(points[pointIndex].x, points[pointIndex].y)];
                  const oldInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveWallObjectInfo(wallList, info.dotList);
                  if (oldInfo != null) {
                    info = oldInfo.clone();
                  } else {
                    info.guid = marietta.webcad.WebCADGlobal.getGuid();
                  }
                  marietta.webcad.WebCADGlobal.itemManager.createItem(info);
                  wallpoints.push({ p1: pos1, p2: points[pointIndex] });
                }
              }
            });
          });
        }

        const missingWalls = marietta.webcad.WebCADGlobal.webcad2Dmanager.findMissingWall(areaPoints, wallpoints, outerPoints); // 壁リストに含まれていない壁があるかどうかを確認
        if (missingWalls.length > 0) {
          missingWalls.forEach((wall: any) => {
            let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
            info.x = 0;
            info.y = 0;
            info.id = 'wal01_01';
            info.dotList = [new PointCollection(wall.p1.x, wall.p1.y), new PointCollection(wall.p2.x, wall.p2.y)];
            const oldInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveWallObjectInfo(wallList, info.dotList);
            if (oldInfo != null) {
              info = oldInfo.clone();
            } else {
              info.guid = marietta.webcad.WebCADGlobal.getGuid();
            }
            marietta.webcad.WebCADGlobal.itemManager.createItem(info);
          });
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();

        this.dotList = [];
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      } else {
        super.endMakeShape();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
      }
    } else {
      this.interrupt();
    }

    // スナップリストの作成
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    marietta.webcad.WebCADGlobal.quotationItemList.createData();

    // 連続入力モード判別
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.continualInput) {
      const actionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = actionMode;
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
      // 部屋種類ラジオボタンのチェックをはずす
      const checkboxes = document.getElementById('roomInputMenuItems').querySelectorAll('input[type="radio"]');
      for (let i = 0; i < checkboxes.length; i += 1) {
        (<HTMLInputElement>checkboxes[i]).checked = false;
      }
    }
  }

  /**
  * 既存の部屋ポイントリスト
  */
  private createRoomVectorList(): void {
    const tarFloor = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);
    const rooms = tarFloor.layer_room.getAllChildren();
    this.roomPointList = [];
    for (let j = 0; j < rooms.length; j += 1) {
      let pList: marietta.core.Point[] = [];
      for (let i = 0; i < rooms[j].itemInfo.dotList.length; i += 1) {
        const p = new marietta.core.Point((rooms[j].itemInfo.dotList[i].x + rooms[j].itemInfo.x), (rooms[j].itemInfo.dotList[i].y + rooms[j].itemInfo.y));
        this.isPointOnWall(p);
        pList.push(p);
      }
      pList.push(new marietta.core.Point((rooms[j].itemInfo.dotList[0].x + rooms[j].itemInfo.x), (rooms[j].itemInfo.dotList[0].y + rooms[j].itemInfo.y)));
      if (marietta.webcad.util.WebCADUtil.isClockwise(pList)) pList = <marietta.core.Point[]>marietta.webcad.util.WebCADUtil.sortListCounterClockwise(pList);
      this.roomPointList[j] = pList;
    }

    // 現在の階の建具の情報を足す;
    const wallList: marietta.webcad.item.WallObject[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_WALL_NO)).getAllChildren();
    const wallPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllWallPointList(wallList);
    for (let j: number = 0; j < wallPointList.length; j += 1) {
      let pList: marietta.core.Point[] = [];
      for (let i = 0; i < wallPointList[j].length; i += 1) {
        const p = new marietta.core.Point(wallPointList[j][i].x, wallPointList[j][i].y);
        this.isPointOnWall(p);
        pList.push(p);
      }
      if (marietta.webcad.util.WebCADUtil.isClockwise(pList)) pList = <marietta.core.Point[]>marietta.webcad.util.WebCADUtil.sortListCounterClockwise(pList);
      // this.roomPointList[j] = pList;
      this.roomPointList.push(pList);
    }
  }

  /**
  * 点が壁にあるかどうかを確認します。 はいの場合、その点をリストに追加します
  * @param p
  * @returns
  */
  isPointOnWall = (p: marietta.core.Point) => {
    let status: boolean = false;
    for (let j = 0; j < this.roomPointList.length; j += 1) {
      for (let i = 0; i < this.roomPointList[j].length - 1; i += 1) {
        if (this.roomPointList[j][i].distanceTo(p) < 5 || this.roomPointList[j][i + 1].distanceTo(p) < 5) {
          status = true;
          break;
        }
        const lineCheck = this.isPointOnLineOrClose(this.roomPointList[j][i], this.roomPointList[j][i + 1], p);
        if (lineCheck.status) {
          status = true;
          this.roomPointList[j].splice(i + 1, 0, lineCheck.crossPoint);
          break;
        }
      }
    }
    return status;
  }

  /**
     *
     * @param p1
     * @param p2
     * @param hitPoint
     * @param distance
     * @returns
     */
  private isPointOnLineOrClose = (p1: marietta.core.Point, p2: marietta.core.Point, hitPoint: marietta.core.Point, distance: number = 5) => {
    const crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint(p1, p2, hitPoint);
    if (crossPoint) {
      const cp = new marietta.core.Point(crossPoint.x, crossPoint.y);
      return ({ status: cp.distanceTo(hitPoint) < distance, crossPoint: cp });
    } return { status: false };
  }
}
export default ItemControllerRoomPointInput;
